module.exports = __webpack_public_path__ + "img/patient-profile-adult.7d0f76d3.png";